import styled from 'styled-components';
import { ImageUploader } from '@landlord-tech/ui-kit-opp';

export const SImageUploader = styled(ImageUploader)`
  &&& {
  }
`;
